import React, { useCallback, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Tab, Tabs, Typography } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMeetingStaffContext } from '../MeetingStaffContext';
import DocumentSection from './DocumentSection';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import RejectSection from './RejectSection';
import TechnicalIssueSection from './TechnicalIssueSection';
import CommentSection from './CommentSection';
import ReviewActions from './ReviewActions';
import WrapUpActions from './WrapUpActions';

import commonStyles from 'styles/common.module.scss';

enum ReviewTab {
  Reject = 'Reject',
  TechnicalIssue = 'TechnicalIssue',
  Comment = 'Comment',
}

const BallotReviewPanel: React.FunctionComponent = () => {
  const { setCurrentReject, setCurrentTechnicalIssue, setCurrentComment } = useMeetingStaffContext();
  const [activeTab, setActiveTab] = useState<string>(ReviewTab.Reject);
  const [resetKey, setResetKey] = useState(0);

  const handleTabChange = useCallback(
    (_: any, value = ReviewTab.Reject) => {
      setActiveTab(value);
      setCurrentReject(undefined);
      setCurrentTechnicalIssue(undefined);
      setCurrentComment(undefined);
    },
    [setCurrentComment, setCurrentReject, setCurrentTechnicalIssue]
  );

  const resetAll = useCallback(() => {
    setActiveTab(ReviewTab.Reject);
    setCurrentReject(undefined);
    setCurrentTechnicalIssue(undefined);
    setCurrentComment(undefined);
    setResetKey((k) => k + 1);
  }, [setCurrentReject, setCurrentTechnicalIssue, setCurrentComment]);

  return (
    <GridContainer key={resetKey}>
      <GridItem>
        <DocumentSection onResetAll={resetAll} />
      </GridItem>
      <GridItem>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              indicatorColor={'primary'}
              textColor={'primary'}
              variant={'scrollable'}
            >
              <Tab value={ReviewTab.Reject} label={'Reject'} className={commonStyles.tab} />
              <Tab value={ReviewTab.TechnicalIssue} label={'Other Technical Issue'} className={commonStyles.tab} />
              <Tab value={ReviewTab.Comment} label={'Comment'} className={commonStyles.tab} />
            </Tabs>
          </Box>
          <TabPanel className={commonStyles.tabPanel} value={ReviewTab.Reject}>
            <RejectSection />
          </TabPanel>
          <TabPanel className={commonStyles.tabPanel} value={ReviewTab.TechnicalIssue}>
            <TechnicalIssueSection />
          </TabPanel>
          <TabPanel className={commonStyles.tabPanel} value={ReviewTab.Comment}>
            <CommentSection />
          </TabPanel>
        </TabContext>
      </GridItem>
      <GridItem>
        <ReviewActions />
      </GridItem>
      <GridItem>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6">Continuing Ballot Review Sections</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <WrapUpActions />
          </AccordionDetails>
        </Accordion>
      </GridItem>
    </GridContainer>
  );
};

export default BallotReviewPanel;
